import {useEffect} from 'react';

import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setPasswordResetEmailAC} from 'store/app/appSlice';
import {resetPasswordACS} from 'store/app/requestAC';
import {setModalAC} from 'store/modal/modalSlice';
import './ResetPassword.scss';

const ResetPassword = () => {
  const {passwordResetEmail} = useGlobalState((state) => state.app);

  const dispatch = useSetGlobalState();

  const onClose = () => dispatch(setModalAC(null));

  const handleResend = () => {
    if (passwordResetEmail) {
      dispatch(resetPasswordACS({data: {email: passwordResetEmail}, isResent: true}));
      onClose();
    }
  };

  useEffect(() => {
    return () => {
      dispatch(setPasswordResetEmailAC(null));
    };
  }, [dispatch]);

  return (
    <div className="reset-password" data-testid="reset-password">
      <div className="reset-password__container">
        <Button variant="empty" className="reset-password__close" onClick={onClose}>
          <Icon icon="close" />
        </Button>
        <Text tag="h4">Password reset request sent</Text>
        <Text tag="p">
          A password reset message was sent to your email address. Please click the link in that message to reset your
          password. If you don’t receive the password reset message within a few moments, please check your spam folder.
        </Text>
      </div>
      <Text tag="p" className="reset-password__resend">
        Didn’t recieve the link?{' '}
        <span className="reset-password__resend-action" role="button" onClick={handleResend}>
          Resend
        </span>{' '}
      </Text>
    </div>
  );
};

export default ResetPassword;
